import React, { useState } from 'react'
import { Pane, Avatar, TickIcon } from 'evergreen-ui'


export function PaintingItem(props) {
    let MATTURL = process.env.AJAXURL+'/assets/materials/';
    return (
        <Pane elevation={props.selected?3:1}   
        width={140} height={140}
        margin={10} padding={8} style={{ display: 'Flex', alignContent: 'center', alignItems: 'center', cursor: 'pointer'}} onClick={(e) => {props.onSelect(e)}}>
        
            <Avatar
                // src={MATTURL+props.option.file+'.jpg'}
                name={props.option.Name}
                backgroundColor={props.option.RGB||"white"}
                size={40}
                marginRight={16}
            />
            {props.option.Name}

            {props.selected && <TickIcon marginLeft="16px" color='green' />}
        </Pane>
    )
}
